import Contact from './contact-us';

export default Contact;
export { Contact };